import { Box } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import AddButton from "../../components/300/AddButton";
import PositionContext from "../../context/PositionContext";
import useAuth from "../../hooks/useAuth";
import Position from "./Position";
import RegisterPosition from "./RegisterPosition";
// import api from "../../api/mainApi";
import useAxiosPrivate from "./../../hooks/useAxiosPrivate";
import CustomizedSnackbars from "../300/curriculum/CustomizedSnackbars";
import { useLocation, useNavigate } from "react-router-dom";


function PositionManagment() {
  const api = useAxiosPrivate();
  let location = useLocation();

  const [value, setValue] = useState("position");
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });

  const { user } = useAuth();

  const positionContext = useContext(PositionContext);
  useEffect(() => {
    api.get("position/positions").then((res) => {
      //console.log(curriculum.data.curriculums);
      console.log(res);
      positionContext.positionDispatch({
        type: "loadPosition",
        positions: res.data.positions,
      });
    });
  }, []);

  useEffect(() => {
    if (location.state?.message) {
      setSnackBarOpen(location.state.open);
      setMessage(location.state.message);
    }
  }, []);

  return (
    <Box sx={{ padding: "2rem 2rem" }}>
      <AddButton
        link={{
          label: "Add Position",
          href: "/position_management/addPosition",
        }}
      />
      {/*<RegisterPosition />*/}
      <Position />
      {snackBarOpen && (
        <CustomizedSnackbars
          {...{ setSnackBarOpen, snackBarOpen, message, overlay: true }}
        />
      )}
    </Box>
  );
}

export default PositionManagment;
